// extracted by mini-css-extract-plugin
module.exports = {"container":"container--SegmentsLayout-Layouts-components__2BIRm","spinner":"spinner--SegmentsLayout-Layouts-components__2HVqH"};